import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Background from './Background';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Background/>
);
reportWebVitals();
